/**
 * Classe que cria a coluna de edição
 *
 * @author: Adalto Junior DATE: 04/08/2013
 *
 */

Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.EditColumn = function (entity) {

    this.getColumn = function () {
        return {

            id: "edit",
            name: "",
            field: "",
            width: 36,
            cssClass: "cell-row",
            sortable: false,
            resizable: false,
            selectable: false,
            formatter: function (row, cell, value, columnDef, dataContext) {

                var id = dataContext.model.attributes.id;
                var link = "";

                if( entity === 'LocationOverrideTimeWindow' ) {

                    link = "<a class='table-action-editlink' href='#/Location/" + App.Forms[entity].dataMapper.location.id + "/" + entity + "/edit/" + id + "'><span class='i18nResource'>&nbsp;</span></a>";

                } else if (entity === 'TimeWindowTypeDays') {

                    link = "<a class='table-action-editlink' href='#/TimeWindowType/" + App.Forms.TimeWindowTypeDays.timeWindowTypeId + "/TimeWindowTypeDays/edit/" + id + "'><span class='i18nResource'>&nbsp;</span></a>";

                } else if (entity === 'HoursOfServiceTypeDays') {

                    link = "<a class='table-action-editlink' href='#/HoursOfServiceType/" + App.Forms.HoursOfServiceTypeDays.hosTypeId + "/HoursOfServiceTypeDays/edit/" + id + "'><span class='i18nResource'>&nbsp;</span></a>";

                } else {

                    link = "<a class='table-action-editlink' href='#/";
                    link += entity;
                    link += "/edit/";
                    link += id;
                    link += "'><span class='i18nResource'>&nbsp;</span></a>";

                }

                return link;

            }
        };
    };
};